import React from 'react'
import ClinicServicesCard from "./ClinicServicesCard";
import VerificationCard from './VerificationCard';

const SettingsTab = () => {
    return (
        <>
            <div className="row mt-3">
                <ClinicServicesCard/>
                <VerificationCard/>
            </div>
        </>
    );
}

export default SettingsTab;